var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parag__reusable"},[_vm._l((_vm.paragraph.reusable_block),function(block){return [_c(_vm.blockType[block.meta.type],{key:block.id,tag:"component",staticClass:"reusable__block",attrs:{"block":block}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }